<template>
    <BasePanel headline="lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PANEL_MATCHING" :alvqa="alvqa">
        <template v-slot:panelContent>
            <v-container fluid v-if="tolerance">
                <v-row v-for="row in rows" :key="row.item.id" :id="'settings-' + row.item.id">
                <!-- Settings name -->
                    <v-col cols="3" :alvqa="alvqa + '-' + row.item.id + '-topic'">{{ $t(row.item.name, row.params) }}</v-col>
                    <v-col>
                    <!-- Settings description -->
                        <v-row class="pr-3 pt-3">
                            <div :alvqa="alvqa + '-' + row.item.id + '-description'">{{ $t(row.item.description, row.params) }}</div>
                        </v-row>
                        <v-row>
                            <v-col cols="7" class="pb-4">
                                <v-row class="pt-0 mt-0">
                                    <v-col cols="10" class="pt-0 mt-0 pb-0">
                                        <SettingsTextfield :item="row.item" :alvqa="alvqa + '-' + row.item.id + '-textfield'" />
                                    </v-col>
                                    <v-col cols="1" class="mt-2 mr-5" :alvqa="alvqa + '-' + row.item.id + '-metric-unit'">
                                        {{ $t('lang_PUBLISHING_SHEETS_CAPTION_SECONDS') }}
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import SettingsTextfield from '../SettingsTextfield'

/** How far apart the start times of an airing and a statement row may be. Rows shaped like the page's own settings
 *  (SettingsTextfield edits item.value; null keeps the default); the page's Save button saves them. */
export default {
    name: 'UsageMatchingSettingsPanel',
    components: { BasePanel, SettingsTextfield },
    data() {
        return {
            alvqa: 'account-settings-usage-matching',
            general: null,
            society: null
        }
    },
    computed: {
        tolerance() { return this.$store.getters.getUsageTolerance },
        rows() {
            return [
                { item: this.general, params: { seconds: this.tolerance.systemDefaultSeconds } },
                { item: this.society, params: { society: this.tolerance.comparedSociety } }
            ]
        }
    },
    watch: {
        // The text fields edit these items; their values are copied into the store's tolerance for saving
        tolerance: {
            immediate: true,
            handler(tolerance) {
                if (!tolerance) return
                const rule = 'integerMinMax:' + tolerance.minSeconds + ',' + tolerance.maxSeconds
                const society = tolerance.comparedSociety
                this.general = {
                    id: 'usage-tolerance-general',
                    name: 'lang_PUBLISHING_USAGE_CAPTION_SETTINGS_TOLERANCE',
                    description: 'lang_PUBLISHING_USAGE_CAPTION_SETTINGS_TOLERANCE_DESCRIPTION',
                    value: tolerance.generalSeconds,
                    default: String(tolerance.systemDefaultSeconds),
                    validation: rule
                }
                this.society = {
                    id: 'usage-tolerance-' + society.toLowerCase(),
                    name: 'lang_PUBLISHING_USAGE_CAPTION_SETTINGS_TOLERANCE_SOCIETY',
                    description: 'lang_PUBLISHING_USAGE_CAPTION_SETTINGS_TOLERANCE_SOCIETY_DESCRIPTION',
                    value: tolerance.societies[society] !== undefined ? tolerance.societies[society] : null,
                    default: tolerance.generalSeconds !== null ? String(tolerance.generalSeconds) : String(tolerance.systemDefaultSeconds),
                    validation: rule
                }
            }
        },
        'general.value'(value) { this.update(t => { t.generalSeconds = value }) },
        'society.value'(value) { this.update(t => { t.societies = { ...t.societies, [t.comparedSociety]: value } }) }
    },
    methods: {
        update(change) {
            const tolerance = JSON.parse(JSON.stringify(this.tolerance))
            change(tolerance)
            if (JSON.stringify(tolerance) !== JSON.stringify(this.tolerance)) this.$store.commit('setUsageTolerance', tolerance)
        }
    }
}
</script>
